import  { FC, Suspense, useState } from 'react';

import { Spin } from 'antd';
import CookieConsent from 'react-cookie-consent';
import { Route, Link } from 'react-router-dom';
import { T } from 'react-translator-component';
import { ThemeProvider } from 'styled-components';

import * as S from './styled';

import { GlobalStyle } from '../../../createGlobalStyle';
import { getToken } from '../../../services/authentication';
import { COLORS } from '../../../utils/theme/colors';
import { themes } from '../../../utils/theme/tenantColors';
import Sidebar from '../../molecules/Sidebar';

const getTheme = () => {
  const tenantTheme: string | null = localStorage.getItem('theme');

  return themes[tenantTheme || 'move'];
};

export type MainContentProps = {
  isUserAuthenticated: boolean
  routes: any
  authToken: string
};

const MainContent: FC<MainContentProps> = ({
  isUserAuthenticated,
  routes,
  authToken
}) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  if (!authToken && isSidebarExpanded) {
    setIsSidebarExpanded(false);
  }

  return (
    <S.MainWrapper>
      <ThemeProvider theme={getTheme}>
        {isUserAuthenticated && authToken && (
          <Sidebar {...{ isSidebarExpanded, setIsSidebarExpanded }} />
        )}

        <S.MainContentWrapper
          isSidebarExpanded={isSidebarExpanded}
          visible={getToken() ? true : false}
        >
          <Suspense
            fallback={(
              <div style={{ textAlign: 'center', paddingTop: '48px' }}>
                <Spin size="large" />
              </div>
            )}
          >
            {routes &&
              routes.map(({ exact, path, component }) => (
                <Route key={`route-${path}`} exact={exact} path={path}>
                  {component}
                </Route>
              ))
            }
          </Suspense>

          <CookieConsent
            location="bottom"
            buttonText={`${T('I Understand')}!`}
            cookieName="accept_lgpd_cookie"
            style={{ background: COLORS.secondary }}
            buttonStyle={{
              color: COLORS.white,
              fontSize: '13px',
              background: COLORS.primary,
            }}
            expires={365}
          >
            {T('This website uses cookies to enhance the user experience')}.{' '}

            {T('By continuing, you agree to our')}{' '}

            <Link to={'/privacy-policy'}>{T('Privacy Policy')}</Link>.
          </CookieConsent>
        </S.MainContentWrapper>
        <GlobalStyle />
      </ThemeProvider>
    </S.MainWrapper>
  );
};

export default MainContent;
